// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__Y3alp","paidOnSiteBox":"styles_paidOnSiteBox__puVD3","backToSpacesBtn":"styles_backToSpacesBtn__Q2wGm"};